var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-option',[_c('template',{slot:"primary"},[_c('slider',{attrs:{"value":_vm.sliderIndex,"values":_vm.speedOptions},on:{"input":_vm.onInput}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }